import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { DynamicReportGeneralCreateComponent } from './dynamic-report-general-create.component';

const routes: Routes = [
    {
        path: '',
        component: DynamicReportGeneralCreateComponent,
    }
];

@NgModule({
    imports: [RouterModule.forChild(routes)],
    exports: [RouterModule]
})
export class DynamicReportGeneralCreateRoutingModule { } 